import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')
const details = () => import('./details/Details.vue')

export const OUTLETS_LIST_PAGE_NAME = 'cabinet:outlets'
export const OUTLET_DETAILS_PAGE_NAME = 'cabinet:outlet-details'
export const OUTLET_CREATE_PAGE_NAME = 'cabinet:outlet-create'
export const OUTLET_UPDATE_PAGE_NAME = 'cabinet:outlet-update'

// URLs
export const OUTLETS_LIST_PAGE_URL = ''
export const OUTLET_DETAILS_PAGE_URL = 'details/:id?/'
export const OUTLET_CREATE_PAGE_URL = 'create/'
export const OUTLET_UPDATE_PAGE_URL = 'update/:id?/'


export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(OUTLETS_LIST_PAGE_URL, list, OUTLETS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'outlets',
        // ...accessPermission([VIEW], options),
      }
    }),
    route(OUTLET_DETAILS_PAGE_URL, details, OUTLET_DETAILS_PAGE_NAME, {
      meta: {
        breadcrumb: 'outlet',
        parent: OUTLETS_LIST_PAGE_NAME,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(OUTLET_CREATE_PAGE_URL, details, OUTLET_CREATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'outlet-create',
        parent: OUTLETS_LIST_PAGE_NAME,
        isNew: true,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(OUTLET_UPDATE_PAGE_URL, details, OUTLET_UPDATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'outlet-update',
        parent: OUTLETS_LIST_PAGE_NAME,
        isUpdate: true,
        isNew: false,
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
